<template>
  <div>
    <el-row>
      <el-col :span="usage == 'teacher' || 'studentVocationalTraining' ? 22 : 14" :xs="24">
        <el-table ref="courseTable" v-loading="loading" :data="courseList">
          <el-table-column v-if="usage == 'activeTraining'" prop="CategoryName" label="业务" min-width="20%">
          </el-table-column>
          <el-table-column prop="CourseName" label="课程"
            :min-width="usage == 'teacher' || 'studentVocationalTraining' ? '15%' : '25%'">
            <template slot-scope="scope">
              <a href="javascript:;" @click="onCourseNameClick(scope.row)">
                <span>{{ scope.row.CourseName }}</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column v-if="usage == 'teacher'" prop="CourseCategoryName" label="课程形式" min-width="20%">
          </el-table-column>

          <el-table-column v-if="usage == 'studentVocationalTraining'" prop="TrainingCategoryName" label="类型"
            min-width="15%"></el-table-column>
          <el-table-column v-if="usage == 'studentVocationalTraining'" prop="CurrentTermName" label="当前学期"
            min-width="15%"></el-table-column>
          <!-- <el-table-column v-if="usage == 'studentVocationalTraining'" prop="TeacherName" label="老师" min-width="15%"></el-table-column> -->

          <el-table-column v-if="usage == 'activeTraining'" prop="CampusName" label="校区" min-width="20%">
          </el-table-column>

          <el-table-column v-if="usage == 'teacher' || usage == 'activeTraining'" prop="AttendRateText" label="出勤率"
            min-width="20%"></el-table-column>
          <el-table-column v-if="usage == 'teacher' || usage == 'activeTraining'" prop="AbsentRateText" label="缺勤率"
            min-width="20%"></el-table-column>

          <!-- <el-table-column v-if="usage == 'student'" prop="TeacherName" label="速成老师" min-width="25%"></el-table-column> -->
          <el-table-column prop="ActiveTimeText" label="激活时间"
            :min-width="usage == 'teacher' || usage == 'studentVocationalTraining' ? '20%' : '25%'">
            <template slot-scope="scope">{{ scope.row.IsActive ? scope.row.ActiveTimeText : "" }}</template>
          </el-table-column>
          <el-table-column prop="IsActive" label="状态"
            :min-width="usage == 'student' ? '10%' : (usage == 'teacher' || usage == 'studentVocationalTraining' ? '18%' : '25%')">
            <template slot-scope="scope">
              <span v-if="!scope.row.IsOnline && scope.row.IsActive" class="color-active">已激活</span>
              <span v-if="scope.row.IsOnline && scope.row.IsActive" class="color-active">直播中<img
                  src="../assets/course-active.png"></span>
              <span v-if="!scope.row.IsActive" class="color-close">关闭</span>
            </template>
          </el-table-column>
          <el-table-column v-if="usage == 'student' || usage == 'studentVocationalTraining'" prop="Content" label="课程内容"
            min-width="25%">
            <template slot-scope="scope">{{ scope.row.IsActive ? scope.row.Content : "" }}</template>
          </el-table-column>
          <el-table-column v-if="usage == 'student'" prop="Content" label="上课形式与回放规则须知（ 需点击阅读 ）"
            min-width="35%">
            <template slot-scope="scope">
              <div v-if="scope.row.HasCourseReplayRule">
                <div v-if="!scope.row.HasReadCourseReplayRule" class="cs-studentSignIn-courseReplayRule">
                  <el-button class="cs-studentSignIn-button-read" size="mini" @click="onCourseReplayRuleClick">未阅读</el-button>
                  <div class="cs-studentSignIn-courseReplayRule-desc">
                    <span class="cs-redLabel">*</span>
                    <span>所有学员在上课或看录播前有义务阅读并熟知
                    【上课形式与回放规则须知】，否则不良后果由学员承担
                    </span>
                  </div>
                </div>
                <div v-else>
                  <el-tag type="success" effect="dark">已阅读</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="(usage == 'teacher' || usage == 'activeTraining')"
            :label="isAssistant ? '进入教室' : '线上课程激活'" width="160">
            <template slot-scope="scope">
              <div class="cs-online-course-actions">
                  <!-- v-if="scope.row.CourseCategory !== global.enumNormalCourseCategory.OfflineCourse" -->
                <el-button class="job-icon on-job-icon" size="mini"     
                  :type="(scope.row.IsActive && !isOnline) || (scope.row.IsActive && !scope.row.IsOnline) ? 'info' : 'primary'"
                  :loading="proccessing"
                  :disabled="(scope.row.IsActive && !isOnline) || (scope.row.IsActive && !scope.row.IsOnline) || (isAssistant && (!scope.row.IsOnline || !scope.row.IsActive)) ? true : false"
                  @click="onActivateOnlineCourse(scope.row)"> {{ (scope.row.IsActive || isAssistant) ? "进入教室" :
                      "设置课程(ClassIn专用)"
                  }}</el-button>
                <el-button v-if="canCancelCourse(scope.row) && scope.row.IsOnline" size="mini" type="danger"
                  @click="onCancelCourseActivation(scope.row)">撤销课节</el-button>
              </div>
              <!-- <el-button v-if="isOnline" type="text" @click="onViewHistory">查看课程记录</el-button> -->
            </template>
          </el-table-column>
          <el-table-column v-if="(usage == 'teacher' || usage == 'activeTraining') && !isAssistant" label="点击激活"
            width="160">
            <template slot-scope="scope">
              <el-button v-if="canCancelCourse(scope.row) && !scope.row.IsOnline" class="job-icon on-job-icon" size="mini" type="danger"
                @click="onCancelCourseActivation(scope.row)">撤销课节</el-button>
              <el-button v-else class="job-icon on-job-icon" size="mini" :type="scope.row.IsActive ? 'info' : 'primary'"
                :loading="proccessing" :disabled="scope.row.IsActive ? true : false"
                @click="onActivateNormalCourse(scope.row)">激活(非ClassIn使用)</el-button>
              <!-- <el-button v-if="isOnline" type="text" @click="onViewHistory">查看课程记录</el-button> -->
            </template>
          </el-table-column>
          <el-table-column v-if="usage == 'student' || usage == 'studentVocationalTraining'"
            :label="isOnline ? '进入教室' : '点击签到'" :min-width="usage == 'studentVocationalTraining' ? '15%' : '25%'">
            <template slot-scope="scope">
              <div v-if="scope.row.IsOnline || (scope.row.CourseCategory !== global.enumNormalCourseCategory.OfflineCourse
                && scope.row.CourseCategory !== global.enumNormalCourseCategory.OMO)">
                <el-button class="job-icon on-job-icon cs-studentSignIn-button" size="mini"
                  v-if="!scope.row.SignInOnlineDisabled"
                  :type="(scope.row.IsActive && !scope.row.HasSigned) || (scope.row.IsActive && scope.row.IsOnline) ? 'primary' : 'info'"
                  :loading="proccessing"
                  :disabled="(scope.row.IsActive && !scope.row.HasSigned) || (scope.row.IsActive && scope.row.IsOnline) ? false : true"
                  @click="onSignCourse(scope.row)">{{ scope.row.IsOnline ? "开始上课" : "签 到" }}</el-button>
                  <span v-else>已禁用</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="showAiCourseEntry" label="AI课程" :min-width="usage == 'student' ? '15%' : '12%'">
            <template slot-scope="scope">
              <el-button v-if="canEnterAiCourse(scope.row)" type="text" size="mini"
                :loading="aiCourseLoadingId === scope.row.CourseId"
                @click="onEnterAiCourse(scope.row)">进入 AI 课程</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <a id="classInLink" style="display:none;" target="_blank"></a>
    <el-dialog title="激活课程" center :close-on-click-modal="false" width="600px" :visible.sync="showActiveCourse"
      top="8vh" @close='oncloseActiveCourse'>
      <courseActive :data="activeCourseData" v-on:closeAddCourse="oncloseActiveCourse" @success="onSuccess">
      </courseActive>
    </el-dialog>
    <el-dialog title="激活课程" center :close-on-click-modal="false" width="600px" :visible.sync="showCourseActiveNormal"
      top="12vh" @close='onClosecourseActiveNormal'>
      <courseActiveNormal :data="courseActiveNormalData" v-on:closeAddCourse="onClosecourseActiveNormal"
        @success="onCourseActiveNormalSuccess"></courseActiveNormal>
    </el-dialog>
    <el-dialog v-if="wechartLoginVisible" title="验证微信" :center="true" :close-on-click-modal="false"
      :visible.sync="wechartLoginVisible" top="8vh">
      <wechartLogin action="validation" @success="onWechartLoginSuccess" @fail="onWechartLoginFail"></wechartLogin>
    </el-dialog>
    <el-dialog title="合同签署" :center="true" :close-on-click-modal="false" :visible.sync="contract.showContractDialog"
      width="800px" top="8vh">
      <div class="contract-viewer-container">
        <contractViewer :courses="contract.courses" v-on:contractSigned="onContractSigned"></contractViewer>
      </div>
    </el-dialog>
    <el-dialog v-if="showCourseReplayRuleDialog" title="上课形式与回放规则须知签署" :center="true" :close-on-click-modal="false" :visible.sync="showCourseReplayRuleDialog"
      width="800px" top="8vh">
      <div class="contract-viewer-container">
        <courseReplayRuleViewer v-on:contractSigned="onCourseReplayRuleSigned"></courseReplayRuleViewer>
      </div>
    </el-dialog>
    <cancelCourseActivationDialog :visible.sync="showCancelDialog" :loading="cancelLoading"
      @submit="submitCancelCourseActivation"></cancelCourseActivationDialog>
  </div>
</template>

<style lang="scss" scoped>
.green-color {
  color: green;
}

.color-active {
  img {
    height: 15px;
    margin-left: 5px;
  }
}

.cs-online-course-actions {
  display: flex;
  flex-direction: column;
  align-items: center;

  /deep/ .el-button + .el-button {
    margin-left: 0;
    margin-top: 8px;
  }
}

.cs-studentSignIn-button {
  width: 80px;
}

.cs-studentSignIn-courseReplayRule{
  .cs-studentSignIn-button-read{
    display: inline-block;
    color: red;
    border: 1px solid red;
  }
  .cs-studentSignIn-courseReplayRule-desc{
    display: inline-block;
  }
}
</style>

<script>
import global_ from "../core/global";
import { getCourseClassInLink, activateCourse, cancelCourseActivation } from "../service/teacherCourse.service.js";
import { signCourse, getStudentCourseClassInLink } from "../service/student.service.js";
import { getPartnerSsoConfig, createSsoTicket } from "../service/ssoAuth.service.js";
import courseActive from "./signInManage/courseActive";
import courseActiveNormal from "./signInManage/courseActiveNormal";
import wechartLogin from "../components/common/wechartLogin";
import contractViewer from "../components/contract/contractViewer";
import courseReplayRuleViewer from "../components/contract/courseReplayRuleViewer";
import cancelCourseActivationDialog from "./signInManage/cancelCourseActivationDialog";
let moment = require("moment");

// 老师课程列表的撤销课节。改为 true 后显示按钮。
const enableTeacherCancelCourse = false;

export default {
  data() {
    return {
      global: global_,
      isAssistant: false,
      isOnline: global_.isOnlineCourse,
      proccessing: false,
      partnerSsoEnabled: false,
      aiCourseLoadingId: 0,
      loading: false,
      showAddCourse: false,
      showActiveCourse: false,
      showCourseActiveNormal: false,
      currentRow: null,
      classInLink: "",
      wechartLoginVisible: false,
      wechatEnable: false,
      courseActiveNormalData: {},
      activeCourseData: {
        universityName: "",
        courseName: "",
        teacherId: 0,
        courseId: 0,
        campusId: 0,
        courseCategory: 0
      },
      contract: {
        showContractDialog: false,
        courses: []
      },
      showCourseReplayRuleDialog: false,
      showCancelDialog: false,
      cancelLoading: false,
      cancelTarget: null
    };
  },
  props: ["courseList", "usage", "groupNumber"],
  components: {
    courseActive,
    courseActiveNormal,
    wechartLogin,
    contractViewer,
    courseReplayRuleViewer,
    cancelCourseActivationDialog
  },
  computed: {
    showAiCourseEntry() {
      return this.partnerSsoEnabled && (this.usage === "student" || this.usage === "teacher");
    }
  },
  created() {
    this.isAssistant = this.USERMANAGER.isAssistantTeacher;
    this.loadPartnerSsoConfig();
  },
  methods: {
    loadPartnerSsoConfig() {
      if (this.usage !== "student" && this.usage !== "teacher") {
        return;
      }
      getPartnerSsoConfig().then(result => {
        if (!!result && result.success && result.data) {
          this.partnerSsoEnabled = !!result.data.Enabled;
        }
      }).catch(() => {
        this.partnerSsoEnabled = false;
      });
    },
    canEnterAiCourse(row) {
      if (!this.partnerSsoEnabled || !row) {
        return false;
      }
      if (row.CourseType !== global_.courseType.university) {
        return false;
      }
      if (this.usage === "student") {
        return !!row.IsAiCourseEnabled;
      }
      if (this.usage === "teacher") {
        return true;
      }
      return false;
    },
    onEnterAiCourse(row) {
      if (!row || this.aiCourseLoadingId) {
        return;
      }
      if (this.usage === "student" && !row.HasReadCourseReplayRule){
        this.$message.warning("请先阅读上课形式与回放规则须知");
        return;
      }
      this.aiCourseLoadingId = row.CourseId;
      createSsoTicket(row.CourseId, row.CourseName).then(result => {
        if (!!result && result.success && result.data && result.data.RedirectUrl) {
          window.open(result.data.RedirectUrl, "_blank");
        } else {
          this.$message.error((result && result.message) || "进入AI课程失败");
        }
        this.aiCourseLoadingId = 0;
      }).catch(() => {
        this.$message.error("进入AI课程失败");
        this.aiCourseLoadingId = 0;
      });
    },
    onWechartLoginFail() {
      this.wechartLoginVisible = false;
    },
    onWechartLoginSuccess() {
      setTimeout(() => {
        this.wechartLoginVisible = false;
        this.handleSignIn();
      }, 2000);
    },
    onClosecourseActiveNormal() {
      this.showCourseActiveNormal = false;
      this.proccessing = false;
    },
    onCourseActiveNormalSuccess(data) {
      this.showCourseActiveNormal = false;
      this.proccessing = false;
      if (!!data.Id) {
        this.currentRow.ActiveTimeText = moment().format('YYYY/MM/DD HH:mm');
        this.currentRow.IsActive = true;
        this.currentRow.IsOnline = false;
        this.currentRow.CourseActivationId = data.Id;
        this.currentRow.CanCancelCourse = true;
        if (data.Link) {
          this.openLink(data.Link);
        }
      }
    },
    isWithinTeacherCancelWindow(startTimeText) {
      if (!startTimeText) {
        return false;
      }
      const start = moment(startTimeText);
      if (!start.isValid()) {
        return false;
      }
      return moment().isSameOrBefore(start.clone().add(30, "minutes"));
    },
    canCancelCourse(row) {
      return !!row
        && row.IsActive
        && row.CanCancelCourse
        && !!row.CourseActivationId
        && enableTeacherCancelCourse
        && !this.isAssistant
        && (this.usage === "teacher" || this.usage === "activeTraining");
    },
    onCancelCourseActivation(row) {
      if (!this.canCancelCourse(row)) {
        this.$message.warning("当前没有可撤销的课节");
        return;
      }
      this.cancelTarget = row;
      this.showCancelDialog = true;
    },
    submitCancelCourseActivation(reason) {
      if (!this.cancelTarget || this.cancelLoading) {
        return;
      }
      this.cancelLoading = true;
      cancelCourseActivation(this.cancelTarget.CourseActivationId, reason).then(result => {
        this.cancelLoading = false;
        if (!!result && result.success) {
          this.showCancelDialog = false;
          this.cancelTarget.IsActive = false;
          const warning = result.data && result.data.Message;
          this.$message({
            message: warning || "课节已撤销",
            type: warning ? "warning" : "success"
          });
        } else {
          this.$message.error((result && result.message) || "撤销课节失败");
        }
      }).catch(() => {
        this.cancelLoading = false;
        this.$message.error("撤销课节失败");
      });
    },
    onViewHistory() {

    },
    openLink(link) {
      if (this.isOnline) {
        this.classInLink = link;
        let a = document.getElementById("classInLink");
        a.setAttribute("href", link);
        a.click();
      }
    },
    onSuccess(data) {
      this.showActiveCourse = false;
      this.proccessing = false;
      if (!!data.Id) {
        this.currentRow.ActiveTimeText = moment().format('YYYY/MM/DD HH:mm');
        this.currentRow.IsActive = true;
        this.currentRow.IsOnline = true;
        this.currentRow.CourseActivationId = data.Id;
        this.currentRow.CanCancelCourse = this.isWithinTeacherCancelWindow(data.StartTimeText);
        this.openLink(data.Link);
      }

    },
    oncloseActiveCourse() {
      this.showActiveCourse = false;
      this.proccessing = false;
    },
    onActivateOnlineCourse(row) {
      this.proccessing = true;
      if (row.IsActive) {
        getCourseClassInLink(row.CourseActivationId).then(result => {
          if (!!result && !!result.success) {
            this.openLink(result.data);
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: result.message,
              type: "error"
            });
          }
          this.proccessing = false;
        })
          .catch(() => {
            this.proccessing = false;
          });
      } else {
        this.activeCourseData = {
          courseType: row.CourseType,
          universityName: row.UniversityAbbrs,
          courseName: row.CourseName,
          teacherId: row.TeacherId,
          courseId: row.CourseId,
          campusId: row.CampusId,
          courseCategory: row.CourseCategory
        };
        this.showActiveCourse = true;
        this.currentRow = row;
      }
    },
    onActivateNormalCourse(row) {
      this.proccessing = true;
      this.currentRow = row;
      this.courseActiveNormalData = {
        courseType: row.CourseType,
        universityName: row.UniversityAbbrs,
        courseName: row.CourseName,
        teacherId: row.TeacherId,
        courseId: row.CourseId,
        campusId: row.CampusId,
        courseCategory: row.CourseCategory
      };
      this.showCourseActiveNormal = true;
      // this.proccessing = true;
      // if (!row.IsActive){
      //   let msg = "您确定要激活 " + row.CourseName + " 这门课吗(非线上课程)？激活后，2小时内无法撤销，请谨慎操作！！"
      //   this.$confirm(msg, "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   })
      //     .then(() => {
      //       this.currentRow = row;
      //       activateCourse(row.TeacherId, row.CourseId, row.CampusId).then(
      //         result => {
      //           if (!!result && result.success) {
      //             row.ActiveTimeText = moment().format('YYYY/MM/DD HH:mm');
      //             row.IsActive = 1;
      //             row.IsOnline = 0;
      //             row.CourseActivationId = result.data.Id;
      //           } else {
      //             this.$message.error(result.message);
      //           }
      //           this.proccessing = false;
      //         }
      //       );
      //     })
      //     .catch(() => {
      //       this.proccessing = false;
      //     });
      // }
    },
    onSignCourse(row) {
      this.currentRow = row;

      if (this.usage == "student" && !row.ContractSigned) {
        this.contract.courses = [row.CourseId];
        this.contract.showContractDialog = true;
        return;
      }

      this.proccessing = true;
      if (row.HasSigned) {
        if (row.IsOnline) {
          getStudentCourseClassInLink(row.CourseId, row.CampusId).then(result => {
            if (!!result && !!result.success) {
              this.openLink(result.data);
            } else {
              this.$message({
                dangerouslyUseHTMLString: true,
                message: result.message,
                type: "error"
              });
            }
            this.proccessing = false;
          })
            .catch(() => {
              this.proccessing = false;
            });
        }
      } else {
        if (this.wechatEnable && row.IsOnline) {
          this.wechartLoginVisible = true;
        } else {
          this.handleSignIn();
        }
      }
    },
    handleSignIn() {
      signCourse(this.currentRow.TeacherId, this.currentRow.CourseId, this.currentRow.CampusId).then(result => {
        if (!!result && result.success) {
          this.currentRow.HasSigned = true;
          this.$message({
            message: "签到成功",
            type: "success"
          });
          if (this.currentRow.IsOnline) {
            this.openLink(result.data.Link)
          } else {
            this.onCourseNameClick(this.currentRow);
          }
        } else {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: result.message,
            type: "error"
          });
        }
        this.proccessing = false;
      })
        .catch(() => {
          this.proccessing = false;
        });
    },
    onCourseNameClick(row) {
      if (this.usage == "student") {
        if(row.IsReviewCourse || row.IsFreeTrial){
          return;
        }
        this.$router.push({
          path: "../page/signDetail.vue",
          name: "studentSignCourseDetail",
          query: {
            teacherId: row.TeacherId,
            courseId: row.CourseId,
            usage: "student"
          }
        });
      } else if (this.usage == "teacher" || this.usage == "activeTraining") {
        this.$router.push({
          path: "/teacher/signInManageView",
          query: {
            back: "courseOperator",
            groupNumber: this.groupNumber,
            teacherId: row.TeacherId,
            courseId: row.CourseId,
            campusId: row.CampusId,
            courseName: row.CourseName,
            teacherName: row.TeacherName,
            campusName: row.CampusName,
            status: row.IsActive ? "已激活" : "关闭"
          }
        });
      } else if (this.usage == "studentVocationalTraining") {
         if(row.IsReviewCourse || row.IsFreeTrial){
          return;
        }
        this.$router.push({
          path: "../page/signDetail.vue",
          name: "studentSignCourseDetail",
          query: {
            teacherId: row.TeacherId,
            courseId: row.CourseId,
            campusId: row.CampusId,
            usage: "studentVocationalTraining"
          }
        });
      }
    },
    onContractSigned(courseIds) {
      this.currentRow.ContractSigned = true;
      if (courseIds) {
        for (let i = 0; i < courseIds.length; i++) {
          let course = this.courseList.find(q => q.CourseId === courseIds[i]);

          if (course)
            course.ContractSigned = true;
        }
      }
      this.contract.showContractDialog = false;
      this.onSignCourse(this.currentRow);
    },
    onCourseReplayRuleClick(){
      this.showCourseReplayRuleDialog = true;
    },
    onCourseReplayRuleSigned(){
      for (let i = 0; i < this.courseList.length; i++) {
        if (this.courseList[i].HasCourseReplayRule && !this.courseList[i].HasReadCourseReplayRule){
          this.courseList[i].HasReadCourseReplayRule = true;
        }
      }
      this.showCourseReplayRuleDialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/courseOperator.vue